var currentUrl = window.location.href;
if(currentUrl.indexOf("%3C%3C") !== -1 && currentUrl.indexOf("%3E%3E") !== -1){
  currentUrl = currentUrl.replace('%3C%3C',"").replace('%3E%3E',"");
  var stateObj = {};
  function change_my_url()
  {
     history.pushState(stateObj, "", currentUrl);
  }
  change_my_url();
}

$( document ).ready(function() {
  
  $( ".grid-product__image-mask" ).each(function() {
    let title = $(this).parent().find('.grid-product__title');

    let first_image = $(this).find('.grid__image-ratio.grid__image-ratio--portrait');
    let sizeDiv = $(this).find('.grid-product__size_container');

    if (true) {
      sizeDiv.clone().addClass('mobile--only').appendTo(first_image);
    }
    
  });
});